import rideStatusMappingToGhealth from './updateRideStatuses';
import vendorPortalProviderStatuses from './vendorPortalProviderStatuses';

export const rideStatuses = {
    rideStatusMappingToGhealth,
    vendorPortalProviderStatuses
};